import { Box, Typography, useTheme, Stack, useMediaQuery } from "@mui/material";
import { careersContent } from "../../data/careersContent";
import ApplyNowButton from "../common/ApplyNowButton";

import { iconsMap } from "../utils/iconsMap";
const { readyToApply } = careersContent;

const NewReadyToApply = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"));

  return (
    <Box
      sx={{
        py: 2,
        //mt: { sm: 10, md: 10, lg: 10 },
      }}
    >
      {/* Heading */}
      <Typography
        variant="h3"
        align="left"
        fontWeight="bold"
        gutterBottom
        sx={{ mb: { md: 3, lg: 6 }, mt: 4 }}
      >
        {readyToApply.heading}
      </Typography>
      <Box
        sx={{
          maxWidth: { lg: "1100px" },
          mx: "auto",
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: { xs: "stretch", md: "center" },
          justifyContent: "center",
          gap: { xs: 3, md: 6 },
        }}
      >
        {/* Texto */}
        <Box
          flex={1}
          sx={{
            maxWidth: { lg: "600px" },
            mx: { xs: "auto", md: 0 },
          }}
        >
          {/* Intro */}
          <Typography
            variant="body1"
            sx={{
              mb: 2,
            }}
          >
            {readyToApply.intro}
          </Typography>
          <Typography
            variant="h5"
            sx={{
              mb: 1,
              maxWidth: "700px",
              fontWeight: "bold",
            }}
          >
            If you are:
          </Typography>
          {/* Requirements */}
          <Stack
            spacing={1.5}
            sx={{
              mb: 3,
              textAlign: "left",
            }}
          >
            {readyToApply.requirements.map((req, i) => {
              const IconComponent =
                iconsMap[req.icon] || iconsMap["CheckCircleIcon"];
              return (
                <Box key={i} sx={{ display: "flex", alignItems: "center" }}>
                  <IconComponent
                    sx={{
                      color: theme.palette.primary.main,
                      mr: 2,
                      fontSize: 25,
                    }}
                  />
                  <Typography variant="body1">{req.text}</Typography>
                </Box>
              );
            })}
          </Stack>
          {/* Highlight Box */}
          <Typography
            variant="body1"
            fontWeight={700}
            sx={{ color: theme.palette.primary.light, mb: 1 }}
          >
            {readyToApply.highlightBox.title}
          </Typography>
          <Typography
            variant="body2"
            sx={{ color: theme.palette.primary.light, mb: 2 }}
          >
            {readyToApply.highlightBox.description}
          </Typography>

          {/* Appy Form Button */}
          <ApplyNowButton label={readyToApply.ctaLabel} />
        </Box>

        {/* Image */}
        {!isMobile && (
          <Box
            flex={1}
            sx={{
              maxWidth: { xs: "auto", sm: "500px" },
              borderRadius: "16px",
              overflow: "hidden",
              boxShadow: theme.shadows[2],
              display: "flex",
              alignItems: "center",
              mt: { xs: 1, sm: 0 },
            }}
          >
            <img
              src="assets/office1.jpeg"
              alt="Team at Hungerford img"
              style={{
                height: "auto",
                objectFit: "initial",
                display: "block",
                borderRadius: "16px",
                maxHeight: "440px",
              }}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default NewReadyToApply;
